export enum NotificationSourceList {
    FYDL = 'FYDL',
    BUSINESS = 'BUSINESS'
}
